export enum ArchivedActivityTableColumnDataIndex {
  Date = "date",
  Activity = "activity",
  Channels = "channel",
  FirstName = "firstName",
  LastName = "lastName",
  Program = "program",
  State = "state",
}
